import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import MellowIllustration from '@/components/MellowIllustration';
import Card from '@/ds-components/Card';

import styles from './index.module.scss';

function SocialDemoCallback() {
  const { t } = useTranslation(undefined, { keyPrefix: 'admin_console' });
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // Social callback will have "code" in query params
    if (searchParams.get('code')) {
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <MellowIllustration scene="applications" />
        <div className={styles.title}>{t('cloud.social_callback.title')}</div>
        <div className={styles.message}>{t('cloud.social_callback.description')}</div>
      </Card>
    </div>
  );
}

export default SocialDemoCallback;
